import { Box, Button, CircularProgress, DialogActions, DialogContent, Divider, Typography } from "@mui/material";
import { FieldValues, useForm, UseFormReturn } from "react-hook-form";
import { useRef } from "react";
import { useStore } from "../../../../store/store";
import { ServiceProvidedInputRef, ServicesProvidedInput } from "./ServicesProvidedInput";
import { Close as CloseIcon, Save as SaveIcon } from "@mui/icons-material";
import { useFields } from "../../../../api/useFields";
import {  ServiceProvided, TreatmentPrescription } from "../types";
import { parseISO } from "date-fns";
import { SERVICES_PROVIDED_ENTITY } from "../utils";

type ServicesProvidedDialogProps = {
	treatmentId: number;
	treatmentPrescription: TreatmentPrescription;
	selectedServiceProvidedId: number | undefined;
};
export const ServicesProvidedDialog = ({
	treatmentId,
	treatmentPrescription,
	selectedServiceProvidedId,
}: ServicesProvidedDialogProps) => {
	const { appDialog } = useStore();
	const { formatedFields: fieldsServicesProv, status: statusFieldsSP } = useFields(SERVICES_PROVIDED_ENTITY);

	const servicesProvided: Array<ServiceProvided> = treatmentPrescription?.[SERVICES_PROVIDED_ENTITY] || [];

	const selectedServiceProvided: ServiceProvided | undefined = selectedServiceProvidedId
		? servicesProvided.find((item) => item.id === selectedServiceProvidedId)
		: undefined;

	const entityForm = useForm({
		mode: "onChange",
		defaultValues: {
      ...selectedServiceProvided,
			treatmentId: treatmentId,
			treatmentPrescriptionId: treatmentPrescription?.id,
			date_begin: selectedServiceProvided?.date_begin ? parseISO(selectedServiceProvided?.date_begin) : null,
      date_end: selectedServiceProvided?.date_end ? parseISO(selectedServiceProvided?.date_end) : null,
      service: selectedServiceProvided?.service
      ? { id: selectedServiceProvided.service.id, label: selectedServiceProvided.service.name }
      : null

		},
	});

	const { isSubmitting } = entityForm.formState;

	const formHandlerRef = useRef<ServiceProvidedInputRef>(null);
	const onSubmit = async (formData: any) => {
		await formHandlerRef.current?.submitFn(formData);
	};

	if (statusFieldsSP === "loading") {
		return (
			<Box display="flex" justifyContent="center" alignItems="center" height="100%" overflow="hidden" mb={4}>
				<CircularProgress size={60} />
			</Box>
		);
	}
	if (statusFieldsSP === "error") {
		return <Typography>Erro ao carregar dados</Typography>;
	}
	if (!fieldsServicesProv) {
		return <Typography>Erro ao carregar dados</Typography>;
	}

	return (
		<Box component={"form"} onSubmit={entityForm.handleSubmit(onSubmit)}>
			<DialogContent>
				<Divider sx={{ mb: 4 }} />
				<ServicesProvidedInput
					entityForm={entityForm as unknown as UseFormReturn<FieldValues>}
					ref={formHandlerRef}
					treatmentPrescriptionId={treatmentPrescription?.id}
					fieldsServicesProv={fieldsServicesProv}
					servicesProvided={servicesProvided}
					selectedServiceProvidedId={selectedServiceProvidedId}
					selectedServiceProvided={selectedServiceProvided}
				/>
			</DialogContent>
			<DialogActions sx={{ padding: 4 }}>
				<Button
					disabled={isSubmitting}
					onClick={() => appDialog.toggleIsOpen()}
					color="secondary"
					startIcon={<CloseIcon />}
				>
					Cancelar
				</Button>
				<Button
					disabled={isSubmitting}
					type="submit"
					color="primary"
					variant="contained"
					startIcon={<SaveIcon />}
				>
					{isSubmitting ? "Guardar..." : "Guardar"}
				</Button>
			</DialogActions>
		</Box>
	);
};
